import { useState } from 'react';

const useLastRefreshedAt = (dataUpdatedAt: number) => {
  const [lastRefreshedAt, setLastRefreshedAt] = useState(dataUpdatedAt);

  if (dataUpdatedAt > lastRefreshedAt) setLastRefreshedAt(dataUpdatedAt);

  return new Date(lastRefreshedAt);
};

export default useLastRefreshedAt;
